var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.063 46.8326V84.1675C115.063 90.2808 111.788 95.9577 106.493 99.0689L74.0706 117.791C68.776 120.848 62.226 120.848 56.8769 117.791L24.4543 99.0689C19.1598 96.0123 15.8848 90.3354 15.8848 84.1675V46.8326C15.8848 40.7193 19.1598 35.0424 24.4543 31.9312L56.8769 13.2091C62.1714 10.1525 68.7214 10.1525 74.0706 13.2091L106.493 31.9312C111.788 35.0424 115.063 40.6647 115.063 46.8326Z",
    stroke: "white",
    strokeWidth: 8.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4997 60.042C72.5236 60.042 78.2176 54.3479 78.2176 47.324C78.2176 40.3001 72.5236 34.6063 65.4997 34.6063C58.4757 34.6063 52.7817 40.3001 52.7817 47.324C52.7817 54.3479 58.4757 60.042 65.4997 60.042Z",
    stroke: "white",
    strokeWidth: 8.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3332 90.9363C87.3332 81.1113 77.5628 73.1425 65.4998 73.1425C53.4369 73.1425 43.6665 81.1113 43.6665 90.9363",
    stroke: "white",
    strokeWidth: 8.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupportIcon);
export default __webpack_public_path__ + "static/media/customer_support_icon.a265e65e47521766622ba4659c65c797.svg";
export { ForwardRef as ReactComponent };